import { Routes } from '@angular/router';
import {HomeComponent} from './home/home.component'
import {ConditionsComponent} from "./conditions/conditions.component";
import {ContactUsComponent} from "./contact-us/contact-us.component";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";
import {EnquireComponent} from "./enquire/enquire.component";
import {OurTeamComponent} from "./our-team/our-team.component";
import {OurTeamDetailComponent} from "./our-team-detail/our-team-detail.component";
import {SitemapComponent} from "./sitemap/sitemap.component";

export const routes: Routes = [
  { path: '', component: HomeComponent },                      // Serve homepage at /
  { path: 'home', redirectTo: '', pathMatch: 'full' },         // Redirect /home to /
  { path: 'conditions', component: ConditionsComponent },
  { path: 'our-team', component: OurTeamComponent },
  {path: 'our-team-detail/:id', component: OurTeamDetailComponent},
  { path: 'contact-us', component: ContactUsComponent},
  { path: 'enquire', component: EnquireComponent},
  {path: 'sitemap', component: SitemapComponent},
  { path: '**', component: PageNotFoundComponent },
];


